<template>
    <vx-modal :visible="Boolean(snippet)" @update:visible="emit('close')" :padding="false" size="md">
        <template v-slot:header>
            <div class="p-6">
                Replace attachment
            </div>
        </template>

        <div class="p-6" v-if="props.snippet">
            <div class="mb-4">
                The snippet contains an attachment. Do you wish to replace the current attachment with the snippet attachment?
            </div>
            <div class="flex flex-col gap-4 lg:flex-row">
                <div class="grow">
                    <strong class="text-slate-800 text-sm">Current attachment:</strong>
                    <message-builder-media-preview
                        :mediaUrl="props.currentMediaUrl"
                        :mediaContentType="props.currentMediaContentType"
                    ></message-builder-media-preview>
                </div>
                <div class="grow">
                    <strong class="text-slate-800 text-sm">Snippet attachment:</strong>
                    <message-builder-media-preview
                        :mediaUrl="props.snippet.media_url"
                        :mediaContentType="props.snippet.media_content_type"
                    ></message-builder-media-preview>

                </div>
            </div>
        </div>

        <template v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <vx-button @click="no()"
                    data-test="swap-no"
                    type="button"
                    size="lg"
                    color="muted">
                    No
                    <font-awesome-icon widthAuto :icon="faCircleX"></font-awesome-icon>
                </vx-button>
                <vx-button @click="yes()"
                    data-test="swap-yes"
                    type="button"
                    size="lg"
                    color="primary"
                    class="lg:grow">
                    Yes
                    <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { VxModal, VxButton } from '@voxie/frontend-components';
import MessageBuilderMediaPreview from './MessageBuilderMediaPreview.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleX, faCircleCheck } from '@fortawesome/pro-solid-svg-icons';

const props = defineProps({
    currentMediaUrl: String,
    currentMediaContentType:  String,
    snippet: Object,
})

const emit = defineEmits(['close', 'no', 'yes']);

const no = () => {
    emit('no', {
        ...props.snippet,
        media_url: undefined,
        media_content_type: undefined,
    });
    emit('close');
}

const yes = () => {
    emit('yes', props.snippet);
    emit('close');
}

</script>
